export default "__VITE_ASSET__lWJJEwUH__"